import { render, staticRenderFns } from "./qaz.vue?vue&type=template&id=0f084398&scoped=true&"
import script from "./qaz.vue?vue&type=script&lang=js&"
export * from "./qaz.vue?vue&type=script&lang=js&"
import style0 from "./qaz.vue?vue&type=style&index=0&id=0f084398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f084398",
  null
  
)

export default component.exports